import { PartialNullable } from "../../Extensions";
import { IPromisePublic, PromiseHelper } from "../../Helpers/PromiseHelper";
import { Property } from "../../RadObject";
import { IDialogResponse } from "../Dialogs/IDialogResponse";
import { ButtonStyleEnum } from "./ButtonStyleEnum";
import { Dialog, DialogPropertyValues, IDialog } from "./Dialog";
import { NAMESPACE } from "./_Namespace";

export type ConfirmSaveChangesDialogPropertyValues =
    DialogPropertyValues
    & {
    };

export type ConfirmSaveChangesDialogProperties = {
    [name in keyof ConfirmSaveChangesDialogPropertyValues]: Property<ConfirmSaveChangesDialogPropertyValues[name]>
};

export interface IConfirmSaveChangesDialog extends IDialog, ConfirmSaveChangesDialogProperties
{
}

let
    dialog: ConfirmSaveChangesDialog,
    dialogQueue: any[] = [];

function checkQueue()
{
    if (!dialog)
        dialog = new ConfirmSaveChangesDialog();

    if (!dialog.opened && dialogQueue.length)
    {
        const
            queueItem = dialogQueue.shift();

        dialog.openAsync(queueItem.properties)
            .then((...args) => { queueItem.promise.resolve(...args); })
            .finally(() => { checkQueue(); });
    }
}

export class ConfirmSaveChangesDialog extends Dialog implements IConfirmSaveChangesDialog
{
    // #region Static

    public static override classNamespace = NAMESPACE + "ConfirmSaveChangesDialog";
    public static override className = "ConfirmSaveChangesDialog";

    // #region Public Methods

    public static display(properties?: any): IPromisePublic<IDialogResponse>
    {
        const
            promise = PromiseHelper.createPromisePublic<IDialogResponse>();

        dialogQueue.push({ promise: promise, properties: properties });
        checkQueue();

        return promise;
    }

    // #endregion

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<ConfirmSaveChangesDialogPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                animationIn: "fade",
                animationOut: null,
                buttonStyle: ButtonStyleEnum.yesNoCancel,
                title: "Save Changes?",
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<ConfirmSaveChangesDialogPropertyValues>)
    {
        super(propertyValues);

        this.addCssClass("rad-control-confirm-save-changes-dialog");
    }

    // #endregion

    // #region Overrides

    protected override _createChildrenHtml()
    {
        return (
            <p>Do you want to save the changes made?</p>
        )
    }

    // #endregion

    // #endregion
}
